import { descartarAccion, NOMBRE_DE_ACCION, type AccionEnCola } from '@/lib/campo/colaDeAcciones'

import estilos from './PaginaMiTrabajo.module.css'

/**
 * LO QUE EL TÉCNICO HIZO SIN SEÑAL Y TODAVÍA NO HA SALIDO, Y LO QUE LA BASE
 * NO ACEPTÓ.
 *
 * Vivía dentro de la lista de trabajos, así que quien no tenía trabajo ese
 * día —pero sí una devolución o un traslado guardados— no lo veía nunca. Y
 * los rechazos se rotulaban con tres frases fijas: un almuerzo rechazado
 * salía como «El avance no se pudo registrar». Ahora cada uno dice qué era y
 * se puede quitar de la vista cuando ya se leyó (auditoría sin conexión,
 * oct 2026).
 */
export function EnEsteTelefono({ pendientes }: { pendientes: AccionEnCola[] }) {
  const esperando = pendientes.filter((m) => !m.rechazada)
  const rechazadas = pendientes.filter((m) => m.rechazada)

  if (pendientes.length === 0) return null

  return (
    <>
      {esperando.length > 0 && (
        <p className={estilos.marcajesEnEspera}>
          <b>
            {esperando.length === 1
              ? `${mayuscula(NOMBRE_DE_ACCION[esperando[0].clase])} está guardada en este teléfono`
              : `${esperando.length} cosas guardadas en este teléfono`}
          </b>
          {esperando.length > 1 && (
            <> ({esperando.map((m) => NOMBRE_DE_ACCION[m.clase]).join(', ')})</>
          )}
          , con la hora en que las hiciste. Se envían solas en cuanto haya señal. No borres la app
          ni cierres sesión mientras tanto.
        </p>
      )}

      {rechazadas.map((m) => (
        <div key={m.id} className={estilos.marcajeRechazado}>
          <b>{mayuscula(NOMBRE_DE_ACCION[m.clase])} no se pudo registrar</b>
          <br />
          {m.ultimoError}
          <button
            type="button"
            className={estilos.entendido}
            onClick={() => void descartarAccion(m.id)}
          >
            Entendido, quitar
          </button>
        </div>
      ))}
    </>
  )
}

const mayuscula = (t: string) => t.charAt(0).toUpperCase() + t.slice(1)
